@if (mode !== 'desktop') {
    <ion-footer class="px-3 py-2 border-top d-lg-none d-flex justify-content-around w-100 fixed-bottom">  
        @for (s of sitemapMenu.slice(0,3); track s) {
            <ng-container *ngTemplateOutlet="footIcon; context: s" />
        }
        
        @if (user().guid) {
            <ng-container *ngTemplateOutlet="footIcon; context: { icon: 'person-circle', label: 'profile', route: 'profile' }" />
        }
        
        <ng-template #footIcon let-i="icon" let-l="label" let-r="route">
            <a class="d-flex flex-column align-items-center text-decoration-none text-white" type="link" routerDirection="root" [routerLink]="'/' + r" routerLinkActive="text-primary" [routerLinkActiveOptions]="{ exact: true }">
                <ion-icon class="f20 mb-2" name="{{ i }}" />
                <span class="px-2 py-0 f12 text-capitalize">{{ l }}</span>
            </a>
        </ng-template>
    </ion-footer>
}
@else {
    <footer class="pt-5 border-top d-none d-lg-block f16"> 
        <div class="row">
            <div class="col-lg-3">
                <img src="/assets/images/nav.webp" alt="UP Station Logo" width="140px" height="27px"  loading="lazy">
                
                <div class="text-white fthin mt-4 pt-1">
                    <b>PT Monetize Indonesia</b><br>
                    Green Lake City Rukan Great Wall<br>
                    Blok B-51, Kel. Petir, Kec. Cipondoh, Tangerang City, Banten 15147<br>
                    Tel. 0813 2228 9962
                </div>
            </div>
    
            <div class="col-lg-3">
                <div class="h4">Sitemaps</div>
    
                <div class="flex-column flex-wrap mt-3 d-flex" *transloco="let t;">
                    @for (s of sitemapMenu; track s) {
                        <a routerLink="/{{ s.route }}" type="link" routerDirection="root" class="fsemibold w-50 text-white text-decoration-none mb-3">
                            {{ t(s.label) }}
                        </a>
                    }
                </div>
            </div>
    
            <div class="col-lg-5 offset-lg-1">
                <div class="h4">Follow Us</div>
                <div class="d-flex mt-3">
                    @for (s of socmedMenu; track s) {
                        <a class="text-decoration-none text-white" href="{{ s.route }}" target="_blank" rel="noopener">
                            <ion-icon name="logo-{{ s.label }}" class="f24 mr-4 cursor-pointer" />
                        </a>
                    }
                </div>
            </div>
        </div>
    
        <div class="border-top mt-5 text-center py-4 px-5">Copyright © {{ year }} PT MONETIZE INDONESIA. All rights reserved</div>
    </footer>
}
